/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2016/12/21
 */
import Loading from './Loading'

export default Loading
